import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';

function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const switchLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };

  return (
    <div>
      <Button onClick={() => switchLanguage('en')}>English</Button>
      <Button onClick={() => switchLanguage('jp')}>日本語</Button>
    </div>
  );
}

export default LanguageSwitcher;
